import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['step', 'item', 'mainStep', 'subStep', 'subStepSticky'];

  static values = { height: Number };

  static classes = ['default', 'sticky', 'itemDefault', 'itemSticky'];

  connect() {
    window.addEventListener('scroll', () => {
      this.handleScroll();
    });

    this.handleScroll();
  }

  handleScroll() {
    const stickyRect = this.stepTarget.getBoundingClientRect();
    stickyRect.top === this.heightValue ? this.addStickyClasses() : this.removeStickyClasses();
  }

  addStickyClasses() {
    this.stepTarget.classList.remove(...this.defaultClasses);
    this.stepTarget.classList.add(...this.stickyClasses);
    this.itemTargets.forEach((target) => {
      target.classList.remove(...this.itemDefaultClasses);
      target.classList.add(...this.itemStickyClasses);
    });

    if (this.hasSubStepTarget) {
      this.mainStepTarget.classList.add('hidden');
      this.subStepTarget.classList.add('hidden');
      this.subStepStickyTarget.classList.remove('hidden');
    }
  }

  removeStickyClasses() {
    this.stepTarget.classList.remove(...this.stickyClasses);
    this.stepTarget.classList.add(...this.defaultClasses);
    this.itemTargets.forEach((target) => {
      target.classList.remove(...this.itemStickyClasses);
      target.classList.add(...this.itemDefaultClasses);
    });

    if (this.hasSubStepTarget) {
      this.mainStepTarget.classList.remove('hidden');
      this.subStepTarget.classList.remove('hidden');
      this.subStepStickyTarget.classList.add('hidden');
    }
  }
}
